// extracted by mini-css-extract-plugin
module.exports = {"container":"SwitchModeBtn_container__180Yo"};